import { useState, useEffect, useRef } from "react";
import { Button } from "antd";
import {
PlusOutlined,
CloseOutlined,
UserAddOutlined,
CheckSquareOutlined,
DollarOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const FloatingActions = () => {
const [open, setOpen] = useState(false);
const navigate = useNavigate();
const ref = useRef();

const handleNavigate = (path) => {
navigate(path);
setOpen(false);
};

// 🔥 close on outside click
useEffect(() => {
const handleClick = (e) => {
if (ref.current && !ref.current.contains(e.target)) {
setOpen(false);
}
};
document.addEventListener("mousedown", handleClick);
return () => document.removeEventListener("mousedown", handleClick);
}, []);

return ( <div ref={ref} className="fab-container">

  {/* ACTION BUTTONS */}
  <div className={`fab-actions ${open ? "open" : ""}`}>

    <Button
      className="fab-item"
      icon={<UserAddOutlined />}
      onClick={() => handleNavigate("/crm/leads")}
    >
      Lead
    </Button>

    <Button
      className="fab-item"
      icon={<CheckSquareOutlined />}
      onClick={() => handleNavigate("/crm/tasks")}
    >
      Task
    </Button>

    <Button
      className="fab-item"
      icon={<DollarOutlined />}
      onClick={() => handleNavigate("/crm/deals")}
    >
      Deal
    </Button>

  </div>

  {/* MAIN BUTTON */}
  <Button
    type="primary"
    shape="circle"
    size="large"
    className="fab-main"
    icon={open ? <CloseOutlined /> : <PlusOutlined />}
    onClick={() => setOpen(!open)}
  />

</div>

);
};

export default FloatingActions;
